import * as React from 'react';

function CashApp(props) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1_611)">
                <rect width="32" height="32" rx="16" fill="#00D632" />
                <path
                    d="M20.2438 2C23.0438 2 24.4437 2 25.975 2.48125C26.7879 2.77862 27.5261 3.24976 28.1382 3.86182C28.7502 4.47388 29.2214 5.2121 29.5188 6.025C30 7.55625 30 8.95625 30 11.7606V20.235C30 23.0438 30 24.4525 29.5188 25.9662C29.2214 26.7791 28.7502 27.5174 28.1382 28.1294C27.5261 28.7415 26.7879 29.2126 25.975 29.51C24.4437 30 23.0438 30 20.2438 30H11.7562C8.9475 30 7.53875 30 6.025 29.5188C5.2121 29.2214 4.47388 28.7502 3.86182 28.1382C3.24976 27.5261 2.77862 26.7879 2.48125 25.975C2 24.4437 2 23.0437 2 20.2394V11.7562C2 8.9475 2 7.53875 2.48125 6.025C2.77862 5.2121 3.24976 4.47388 3.86182 3.86182C4.47388 3.24976 5.2121 2.77862 6.025 2.48125C7.55625 2 8.95625 2 11.7562 2H20.2438Z"
                    fill="#00D632"
                />
                <path
                    d="M20.5806 12.4125C20.7994 12.6312 21.1625 12.6312 21.3681 12.4125L22.4619 11.275C22.6937 11.0562 22.6806 10.6625 22.4356 10.4262C21.5761 9.67763 20.5769 9.10665 19.4956 8.74625L19.8412 7.08375C19.9156 6.72062 19.6444 6.37937 19.2812 6.37937H17.1637C17.0314 6.38079 16.9035 6.42763 16.8016 6.51205C16.6997 6.59647 16.6298 6.71335 16.6037 6.84312L16.2975 8.32187C13.48 8.46625 11.0912 9.89687 11.0912 12.8281C11.0912 15.3656 13.0644 16.455 15.1512 17.2031C17.1244 17.9556 18.17 18.2356 18.17 19.2944C18.17 20.3837 17.1287 21.0225 15.5887 21.0225C14.1887 21.0225 12.7187 20.5544 11.5812 19.4125C11.5284 19.3596 11.4657 19.3176 11.3966 19.289C11.3275 19.2603 11.2535 19.2456 11.1787 19.2456C11.104 19.2456 11.0299 19.2603 10.9609 19.289C10.8918 19.3176 10.8291 19.3596 10.7762 19.4125L9.59499 20.5937C9.48385 20.7053 9.42145 20.8563 9.42145 21.0137C9.42145 21.1712 9.48385 21.3222 9.59499 21.4337C10.5137 22.3394 11.6775 22.9956 13.004 23.3587L12.6802 24.9206C12.6059 25.2837 12.8727 25.6206 13.2359 25.625L15.3577 25.6425C15.4916 25.6431 15.6215 25.5972 15.7252 25.5126C15.829 25.428 15.9001 25.31 15.9265 25.1787L16.2327 23.6956C19.6225 23.4681 21.6875 21.6 21.6875 18.8744C21.6875 16.3631 19.6312 15.3044 17.1375 14.4425C15.7112 13.9131 14.4775 13.55 14.4775 12.4606C14.4775 11.4019 15.6281 10.9819 16.7831 10.9819C18.2531 10.9819 19.6662 11.59 20.5894 12.4212L20.5806 12.4125Z"
                    fill="white"
                />
            </g>
            <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="15.5"
                stroke="#B0C9EB"
            />
            <defs>
                <clipPath id="clip0_1_611">
                    <rect width="32" height="32" rx="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default CashApp;
